import { features } from '@/mocks/site';

export default function Features() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            为什么选择问鼎下载？
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            六大核心优势，打造极致的下载体验，让每一次下载都安心无忧
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}